<template>
    <v-layout row class="consent-request">
        <v-flex xs12 sm6 offset-sm3>
            <v-card>
                <v-card-media :src="picture" height="300px">
                    <v-layout column class="media">
                        <v-card-title>
                            <v-btn dark icon>
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-menu bottom left>
                                <v-btn icon slot="activator" dark>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile @click="signOut()">
                                        <v-list-tile-title>Sign out</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-card-title class="white--text pl-5 pt-5">
                            <div class="display-1 pl-5 pt-5">{{ profile.name }}</div>
                        </v-card-title>
                    </v-layout>
                </v-card-media>

                <v-card-text v-if="intent" >
                    <div class="title">{{ intent.ShortDescription }}</div>
                    <div class="subheading pt-3">{{ intent.Description }}</div>

                    <v-list one-line v-if="intent">
                        <v-divider></v-divider>
                        <v-list-tile v-for="Scope in intent.Scopes" :key="Scope">
                            <v-list-tile-content>
                                <v-list-tile-sub-title class="title subheading">{{ Scope }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn flat>
                                    <v-icon>info</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                        <v-dialog
                                class="pt-2"
                                persistent
                                v-model="modal"
                                lazy
                                full-width
                        >
                            <v-text-field
                                    slot="activator"
                                    label="Expiration date"
                                    prepend-icon="event"
                                    readonly
                                    :value="consent.Expiration"
                                    @input="updateExpiration"
                            ></v-text-field>
                            <v-date-picker
                                    scrollable
                                    :value="consent.Expiration"
                                    @input="updateExpiration"
                            >
                                <template scope="{ save, cancel }">
                                    <v-card-actions>
                                        <v-btn flat primary @click.native="cancel()">Cancel</v-btn>
                                        <v-btn flat primary @click.native="save()">Save</v-btn>
                                    </v-card-actions>
                                </template>
                            </v-date-picker>
                        </v-dialog>

                        <div column class="pl-3 pr-3">
                            <div class="justify title caption">
                                {{ issuer.Name }} and NowYu will use this information in accordance with their respective terms of service and privacy policies.
                            </div>
                        </div>
                    </v-list>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="back()">Cancel</v-btn>
                    <v-btn primary :disabled="!isAcceptable" @click="accept()">Grant</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'ConsentRequest',
        data() {
            return {
                modal: false,
            };
        },
        computed: {
            ...mapGetters('auth', [
                'profile',
            ]),
            ...mapGetters('consents', [
                'issuer',
                'intent',
                'consent',
                'redirect',
                'isAcceptable',
            ]),
            picture() {
                if (this.profile) {
                    return this.profile.picture;
                }

                return undefined;
            },
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
            signOut() {
                this.$store.commit('auth/LOGOUT');
                this.$router.push({ path: '/login' });
            },
            accept() {
                this.$store.dispatch('consents/ACCEPT')
                    .then(
                        () => {
                            window.location.href = this.redirect;
                        },
                    );
            },
            updateExpiration(value) {
                this.$store.commit('consents/UPDATE_EXPIRATION', value);
                this.modal = false;
            },
        },
        created() {
            this.$store.dispatch('consents/LOAD_CONSENT');
        },
    };
</script>

<style lang="stylus" scoped>
    .card__media
        background-color: #37345a

    .card__media__background
        -webkit-filter: opacity(20%)
        filter: opacity(20%)

</style>



// WEBPACK FOOTER //
// ConsentRequest.vue?19ebcac1